module.exports = __webpack_public_path__ + "img/des_pintu_4.2559a7ab.jpg";